import {
  COMMENT_DETAILS,
  POST_DETAILS_ROUTE
} from 'src/app/modules/layouts/pages/dashboard/pages/posts/constants/routes.constants';
import {
  Injectable,
  NgZone
} from '@angular/core';

import { DASHBOARD_CHAT_ROUTE, DASHBOARD_HOME_ROUTE, DASHBOARD_SQUAWKPIT_ROUTE, DASHBOARD_EVENTS_ROUTE, DASHBOARD_COMMUNITY_GROUP_ROUTE, DASHBOARD_PROFILE_ROUTE } from 'src/app/modules/layouts/pages/dashboard/constants/dashboar.routes.constants';
import { NOTIFICATION_PUSH_CONSTANTS } from 'src/app/constants/app.constants';
import { NotificationModel } from 'src/app/modules/layouts/components/shared/models/notifications.model';
import { ProfileService } from '../profile/profile.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { UserProfileModel } from 'src/app/models/user-models/user.profile.model';

declare interface NotificationData {
  count?: number,
  flag: boolean,
  isChatPush?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class StateManagerService {
  headerClass: Subject<any> = new Subject();
  notificationCount$: Subject<NotificationData> = new Subject();
  chatCount: number = 0;
  latitude: any;
  longitude: any;
  location$: Subject<any> = new Subject();
  chatNotificationCount$: Subject<{
    flag: boolean,
    apiHit?: boolean,
    resetCount?: boolean, isChatPage: boolean, count?: number, countUpdate: boolean
  }> = new Subject();
  /**
   * @description
   * handle Events Modules States of the following
   */
  showSidenav: Subject<boolean> = new Subject();
  eventCategoryFilter$: Subject<any> = new Subject();
  eventSearchFilter$: Subject<any> = new Subject();

  get locationObject() {
    return { latitude: this.latitude, longitude: this.longitude }
  }
  set locationObject(obj: { longitude: number, latitude: number }) {
    this.latitude = obj.latitude;
    this.longitude = obj.longitude;
  }
  /**
   * @description
   * handle comments count state in posts
   */
  commentCountUpdate$: Subject<any> = new Subject();

  profileDetails: UserProfileModel;
  constructor(private $router: Router,
    private $ngZone: NgZone,
    private $profile: ProfileService) {
    this.$profile.changes.subscribe(data => {
      this.profileDetails = data;
    })
    this.chatNotificationCount$.subscribe(data => {
      if (data.count >= 0) {
        this.chatCount = data.count;

      }
      if (!data.count && data.countUpdate) {
        this.chatCount++;
      }
      if (data.resetCount) {
        this.chatCount = 0;
      }

    })
  }

  /****
   * @param data
   * @description
   * handling navigation of the notification message
   */
  handleNavigationViaPush(data: NotificationModel | any, isInsideZone: boolean = true) {
    if (data.type === NOTIFICATION_PUSH_CONSTANTS.BULK_NOTIFICATION || data.type === NOTIFICATION_PUSH_CONSTANTS.ONE_TO_ONE) {
      if (this.navigateFromRedirectOrLink(data, isInsideZone)) {
        return;
      }
      return;
    }

    // Handle admin_broadcast notifications
    if (data.notificationType === 'admin_broadcast') {
      this.navigateFromRedirectOrLink(data, isInsideZone);
      return;
    }

    let navigateUrl: string = ''
    let queryParam: string = ''
    let hasSpecificNavigation = false
    if (data.type == NOTIFICATION_PUSH_CONSTANTS.FOLLOW_USER) {
      if (data.senderId == this.profileDetails.userId) {
        if (!isInsideZone) {
          this.$ngZone.run(() => {
            this.$router.navigate(['/dashboard/profile']);
          })
        } else {
          this.$router.navigate(['/dashboard/profile']);
        }
        return;
      } else {
        if (!isInsideZone) {
          this.$ngZone.run(() => {
            this.$router.navigate(['/dashboard/profile'], { queryParams: { userId: data.senderId } })
            // this.$router.navigate(['/dashboard/profile/viewall'], { queryParams: { type: 'followers', userId: data.senderId}})
          })
        } else {
          this.$router.navigate(['/dashboard/profile'], { queryParams: { userId: data.senderId } })
          // this.$router.navigate(['/dashboard/profile/viewall'], { queryParams: { type: 'followers', userId: data.senderId } })

        }
        // ?type = followers & userId=5f478ad3412ab1207d79ad4d
        return;
      }
    }
    if (this.navigateFromRedirectOrLink(data, isInsideZone)) {
      return;
    }
    /**
     * @description
     * handles navigation of push on the basis of type
     */
    if (data.type === NOTIFICATION_PUSH_CONSTANTS.CREATE_EVENT) {
      navigateUrl = `/dashboard/events/${data.eventId}`
      hasSpecificNavigation = true
    } else if (data.type == NOTIFICATION_PUSH_CONSTANTS.COMMENT_ON_POST || data.type == NOTIFICATION_PUSH_CONSTANTS.COMMENT_LIKE || data.type == NOTIFICATION_PUSH_CONSTANTS.POST_COMMENT_REPLY || data.type == NOTIFICATION_PUSH_CONSTANTS.MENTION_POST_COMMENT || data.type == NOTIFICATION_PUSH_CONSTANTS.MENTION_POST_COMMENT_REPLY) {
      /**
       * @description
       * navigates to the post details page
       */
      navigateUrl = POST_DETAILS_ROUTE.url(data.postId);
      hasSpecificNavigation = true
    }
    else if (data.type == NOTIFICATION_PUSH_CONSTANTS.POST_LIKE || data.type == NOTIFICATION_PUSH_CONSTANTS.CREATE_NEW_POST || data.type == NOTIFICATION_PUSH_CONSTANTS.MENTION_USER_POST) {
      navigateUrl = POST_DETAILS_ROUTE.url(data.postId);
      hasSpecificNavigation = true
    } else if (data.type === NOTIFICATION_PUSH_CONSTANTS.ANSWER_REPLY_DOWNVOTE || data.type === NOTIFICATION_PUSH_CONSTANTS.ANSWER_REPLY_UPVOTE || data.type === NOTIFICATION_PUSH_CONSTANTS.CREATE_ANSWER_REPLY || data.type === NOTIFICATION_PUSH_CONSTANTS.TOPIC_DOWNVOTE || data.type === NOTIFICATION_PUSH_CONSTANTS.TOPIC_UPVOTE || data.type === NOTIFICATION_PUSH_CONSTANTS.TOPIC_ANSWER_UPVOTE || data.type === NOTIFICATION_PUSH_CONSTANTS.TOPIC_ANSWER_UPVOTE || data.type == NOTIFICATION_PUSH_CONSTANTS.CREATE_TOPIC_ANSWER || data.type === NOTIFICATION_PUSH_CONSTANTS.CREATE_TOPIC) {
      navigateUrl = `/dashboard/forum/${data.questionId}`
      hasSpecificNavigation = true
    } else if (data.type === NOTIFICATION_PUSH_CONSTANTS.CREATE_BUSINESS || data.type === NOTIFICATION_PUSH_CONSTANTS.FOLLOW_BUSINESS) {
      navigateUrl = `/dashboard/mybusiness/${data.businessId}`
      hasSpecificNavigation = true
    } else if (data.type === NOTIFICATION_PUSH_CONSTANTS.ADDED_BUSINESS_REVIEW) {
      navigateUrl = `/dashboard/business/reviews/${data.businessId}`
      hasSpecificNavigation = true
    } else if (data.type === NOTIFICATION_PUSH_CONSTANTS.CHAT_NOTIFICATION) {
      navigateUrl = DASHBOARD_CHAT_ROUTE.url
      hasSpecificNavigation = true
    }
    
    // Check if there are IDs that indicate navigation even when type is "normal"
    // This handles cases where API returns type: "normal" but has commentId, postId, etc.
    if (!hasSpecificNavigation && data.type === 'normal') {
      // Navigate to post page for notifications with postId (including comment-related notifications)
      if (data.postId && typeof data.postId === 'string' && data.postId.trim() !== '') {
        navigateUrl = POST_DETAILS_ROUTE.url(data.postId);
        hasSpecificNavigation = true
      } else if (data.eventId && typeof data.eventId === 'string' && data.eventId.trim() !== '') {
        navigateUrl = `/dashboard/events/${data.eventId}`
        hasSpecificNavigation = true
      } else if (data.businessId && typeof data.businessId === 'string' && data.businessId.trim() !== '') {
        navigateUrl = `/dashboard/mybusiness/${data.businessId}`
        hasSpecificNavigation = true
      } else if (data.questionId && typeof data.questionId === 'string' && data.questionId.trim() !== '') {
        navigateUrl = `/dashboard/forum/${data.questionId}`
        hasSpecificNavigation = true
      }
    }

    // If we have a specific navigation path, use it
    if (hasSpecificNavigation && navigateUrl) {
      if (isInsideZone) {
        this.$ngZone.run(() => {
          this.$router.navigate([navigateUrl]);
        })
      } else {
        this.$ngZone.run(() => {
          this.$router.navigate([navigateUrl]);
        })
      }
      return;
    }

    // Only check for URL in message if no specific navigation was found
    const messageText = data.message || data.completeMessage || '';
    if (messageText) {
      const extractedUrl = this.extractUrlFromText(messageText);
      if (extractedUrl) {
        // Ensure URL has protocol
        const urlWithProtocol = extractedUrl.startsWith('http://') || extractedUrl.startsWith('https://') 
          ? extractedUrl 
          : `https://${extractedUrl}`;
        window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
        return;
      }
    }

    // Fallback to normal navigation if navigateUrl was set but hasSpecificNavigation wasn't
    if (navigateUrl) {
      if (isInsideZone) {
        this.$ngZone.run(() => {
          this.$router.navigate([navigateUrl]);
        })
      } else {
        this.$ngZone.run(() => {
          this.$router.navigate([navigateUrl]);
        })
      }
    }

  }

  /**
   * Maps API `redirectTo` keys (e.g. events, profile) to dashboard routes.
   */
  private resolveInternalRedirectTo(redirectTo: string): string | null {
    switch (redirectTo.toLowerCase()) {
      case 'home':
        return DASHBOARD_HOME_ROUTE.url;
      case 'forum':
        return DASHBOARD_SQUAWKPIT_ROUTE.url;
      case 'events':
        return DASHBOARD_EVENTS_ROUTE.url;
      case 'group':
        return DASHBOARD_COMMUNITY_GROUP_ROUTE.url;
      case 'profile':
        return DASHBOARD_PROFILE_ROUTE.url;
      default:
        return null;
    }
  }

  /**
   * Opens external `link` or navigates using internal `redirectTo`. Returns true if handled.
   */
  private navigateFromRedirectOrLink(data: NotificationModel | any, isInsideZone: boolean): boolean {
    const link = data.link;
    if (link && typeof link === 'string' && link.trim() !== '') {
      const urlWithProtocol = link.startsWith('http://') || link.startsWith('https://')
        ? link
        : `https://${link}`;
      window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
      return true;
    }
    const redirectTo = data.redirectTo;
    if (redirectTo && typeof redirectTo === 'string' && redirectTo.trim() !== '') {
      const navigateUrl = this.resolveInternalRedirectTo(redirectTo);
      if (navigateUrl) {
        this.$ngZone.run(() => {
          this.$router.navigate([navigateUrl]);
        });
        return true;
      }
    }
    return false;
  }

  /**
   * @description
   * Extract URL from text - checks if entire text is a URL or extracts first URL from text
   * @param text - Text to extract URL from
   * @returns string | null - Extracted URL or null if no URL found
   */
  private extractUrlFromText(text: string): string | null {
    if (!text || typeof text !== 'string') {
      return null;
    }
    
    const trimmedText = text.trim();
    
    // Pattern to match URLs with protocol (http:// or https://) - most common case
    const urlWithProtocolPattern = /https?:\/\/[^\s<>"']+/i;
    const matchWithProtocol = trimmedText.match(urlWithProtocolPattern);
    if (matchWithProtocol) {
      return matchWithProtocol[0];
    }
    
    // Pattern to match URLs without protocol but starting with www.
    const wwwPattern = /^www\.[^\s<>"']+/i;
    const matchWww = trimmedText.match(wwwPattern);
    if (matchWww) {
      return matchWww[0];
    }
    
    // Pattern to match domain-like patterns (e.g., meet.google.com, example.com/path)
    // This checks if the entire text looks like a URL
    const domainPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?:\/[^\s<>"']*)?$/i;
    if (domainPattern.test(trimmedText)) {
      // Additional check: must contain a TLD or be a known service domain
      if (/\.(com|net|org|io|co|edu|gov|me|tv|info|biz|us|uk|ca|au|de|fr|it|es|nl|pl|ru|jp|cn|in|br|mx|google|microsoft|apple|amazon|facebook|twitter|instagram|linkedin|youtube|github|stackoverflow|reddit|wikipedia|medium|netflix|spotify|discord|slack|zoom|teams|meet)/i.test(trimmedText)) {
        return trimmedText;
      }
    }
    
    return null;
  }

}
